import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { VaFormsModule } from '@vendasta/forms';
import {
  DateRangeSelectorModule,
  EmptyStateModule,
  VaCardsModule,
  VaFilterModule,
  VaIconModule,
  VaMultiSelectModule,
  VaSearchSelectModule,
  VaStencilsModule,
} from '@vendasta/uikit';
import { FilterModule } from '@vendasta/va-filter2';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import baseTranslation from '../assets/i18n/en_devel.json';
import { PreferredCurrencyModule } from '../currency/preferred-currency.module';
import { VoiceDictationModule } from '../voice-dictation/voice-dictation.module';
import { CommentListComponent } from './comment-list/comment-list.component';
import { CommentComponent } from './comment/comment.component';
import { MultiSelectionDialogComponent } from './loop-v2-filters/filter-dialogs/multi-selection-dialog/multi-selection-dialog.component';
import { SingleSelectionDialogComponent } from './loop-v2-filters/filter-dialogs/single-selection-dialog/single-selection-dialog.component';
import { LoopFilterChipComponent } from './loop-v2-filters/loop-filter-chip/loop-filter-chip.component';
import { LoopV2FiltersComponent } from './loop-v2-filters/loop-v2-filters.component';
import { PostContentComponent } from './post-content/post-content.component';
import { PostComponent } from './post/post.component';

@NgModule({
  imports: [
    CommonModule,
    VaMultiSelectModule,
    MatDatepickerModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    VaSearchSelectModule,
    VaIconModule,
    VaStencilsModule,
    EmptyStateModule,
    VaFormsModule,
    FormsModule,
    ReactiveFormsModule,
    PreferredCurrencyModule,
    FilterModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: 'frontend/sales-common',
      baseTranslation: baseTranslation,
    }),
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    InfiniteScrollModule,
    MatMenuModule,
    MatDialogModule,
    MatAutocompleteModule,
    DateRangeSelectorModule,
    ClipboardModule,
    VaFilterModule,
    VaCardsModule,
    VoiceDictationModule,
  ],
  declarations: [
    LoopV2FiltersComponent,
    PostComponent,
    CommentListComponent,
    CommentComponent,
    LoopFilterChipComponent,
    MultiSelectionDialogComponent,
    SingleSelectionDialogComponent,
    PostContentComponent,
  ],
  exports: [LoopV2FiltersComponent, PostContentComponent],
})
export class LoopV2Module {}
